import React, { useEffect, useState } from 'react';

import { Button } from '@mui/material';

import { getDate } from '../../utils/functions/Utils';

import './styles.css';

const FormatoValeEntrada = (props) => {

    const [renderHoja, setRenderHoja] = useState(<></>);
    const [refacciones, setRefacciones] = useState([]);
    const [cotizacion, setCotizacion] = useState({});
    const [infoServicio, setInfoServicio] = useState({});
    const [cliente, setCliente] = useState('');
    const [solicitante, setSolicitante] = useState('');
    const [entrada, setEntrada] = useState({});
    const [userType, setUserType] = useState('');

    // funcion para imprimir el formato
    const printDocument = () => {
        let printContents = document.getElementById('printDiv').innerHTML;
        localStorage.setItem('printContent', JSON.stringify({ printContents: printContents, name: `ValeEntrada` }));
        window.open('/print', '_blank');
    }

    // genera el formato de la cotizacion dependiendo del layout
    const getSuministros = (refacciones) => {
        return (
            <>
                <div style={{ width: '770px', borderRadius: '5px', marginLeft: '23px' }}>
                    <div className='d-flex align-items-stretch' >
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center text-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', width: '60px', border: 'solid black 0.5px', borderTopLeftRadius: '4px' }}>&nbsp;&nbsp;Cantidad </p>
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '140px' }}>Item</p>
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '400px' }}>Descripción</p>
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '170px', borderTopRightRadius: '4px' }}>Ubicación</p>
                    </div>
                    <div>
                        {refacciones.map(r => (
                            <div className='d-flex' key={`${r.id}Salida`}>
                                <p className='mb-0 d-flex align-items-center justify-content-center' style={{ color: '#000', fontSize: '10px', width: '60px', border: 'solid black 0.5px' }}>&nbsp;&nbsp;{r.cantidad}</p>
                                <div style={{ border: 'solid black 0.5px', width: '140px' }} className='d-flex flex-column align-items-center justify-content-center'>
                                    <p className='mb-0 px-1' style={{ color: '#000', fontSize: '10px' }}>{r.clave}</p>
                                </div>
                                <p className='mb-0 d-flex align-items-center justify-content-center text-center' style={{ color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '400px' }}>{r.descripcion}</p>
                                <div style={{ border: 'solid black 0.5px', width: '170px' }} className='d-flex flex-row align-items-center justify-content-center'>
                                    <p className='mb-0 px-1' style={{ color: '#000', fontSize: '8px', maxWidth: '170px' }}>
                                        {
                                            r.ubicacion ? r.ubicacion : ''
                                        }
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <hr className='my-2' style={{ color: '#555999' }}></hr>
                <div className='justify-content-center' style={{ zIndex: '1', marginLeft: '23px' }}>
                    <div className='d-flex flex-row'>

                        <div style={{ marginLeft: '0px', color: '#000' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginLeft: '24px' }}>
                                    <p style={{ fontSize: '8px', marginBottom: '4px' }}>Recibe:</p>
                                    <div style={{ display: 'flex', justifyContent: 'center', height: '20px' }}></div>
                                    <p className='mb-0 text-center' style={{ fontSize: '8px' }}>___________________________</p>
                                    <p className='mb-0 text-center text-bold' style={{ fontSize: '8px' }}>{props.recibe}</p>
                                </div>
                                <div style={{ marginLeft: '24px' }}>
                                    <p style={{ fontSize: '8px', marginBottom: '4px' }}>Entrega:</p>
                                    <div style={{ display: 'flex', justifyContent: 'center', height: '20px' }}></div>
                                    <p className='mb-0 text-center' style={{ fontSize: '8px' }}>___________________________</p>
                                    <p className='mb-0 text-center text-bold' style={{ fontSize: '8px' }}>{props.entrega}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    useEffect(() => {
        if (props.productos) {
            setRenderHoja(
                <div id='printDiv' style={{ position: 'absolute', width: '816px', height: '1056px', background: '#FFF', zIndex: '1', transformOrigin: '0 0', transform: 'scale(1.4)' }} className='exo2 p-0' contentEditable="true" suppressContentEditableWarning={true}>
                    <img src={`/${props.company}/vale-entrada-bg.svg`} alt='juvalfri-logo' style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: '-2' }} />
                    <div style={{ height: '60px' }}>
                    </div>

                    <div style={{ height: '468px' }}>

                        <div style={{ width: '715px !important', maxHeight: '40px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginLeft: '23px' }}>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Proveedor: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{props.proveedor}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Fecha de Entrada: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{getDate(props.fechaDeEntrada, 'DDDD H:mm:ss').toUpperCase()}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Motivo de Entrada: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{props.motivo}</p>
                            </div>
                        </div>

                        <hr className='my-1' style={{ color: '#555999' }} />

                        <div style={{ marginTop: '12px' }}>
                            {getSuministros(props.productos)}
                        </div>
                    </div>

                    <div style={{ height: '528px' }}>
                        <div style={{ height: '60px' }}></div>

                        <div style={{ width: '715px !important', maxHeight: '40px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginLeft: '23px' }}>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Proveedor: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{props.proveedor}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Fecha de Entrada: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{getDate(props.fechaDeEntrada, 'DDDD H:mm:ss').toUpperCase()}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Motivo de Entrada: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{props.motivo}</p>
                            </div>
                        </div>

                        <hr className='my-1' style={{ color: '#555999' }} />

                        <div style={{ marginTop: '12px' }}>
                            {getSuministros(props.productos)}
                        </div>
                    </div>
                </div>
            )
        }
    }, [props])

    return (
        <div className='exo2'>
            <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <Button className='mx-2' variant='contained' color='secondary' onClick={printDocument}>Imprimir hoja &nbsp; <i className="fad fa-print" style={{ transform: 'scale(1.3)' }}></i></Button>
            </div>
            {renderHoja}
        </div>
    )
}

export default FormatoValeEntrada;